import { HStack } from "@chakra-ui/react";
import CDS from "design-system";

interface Props {
  label: string;
  onUndo: () => void;
  onClose: () => void;
}

export default function UndoDeleteToast({ label, onUndo, onClose }: Props) {
  return (
    <HStack
      bg="bg.primary"
      borderRadius="base"
      borderWidth="1px"
      borderColor="border.subtle"
      px={4}
      py={3}
      spacing={4}
    >
      <CDS.Text12 color="content.primary">{label}</CDS.Text12>
      <CDS.Button
        intent={CDS.Button.intent.indigo}
        variant={CDS.Button.variant.link}
        size="sm"
        onClick={() => {
          onUndo();
          onClose();
        }}
      >
        Undo
      </CDS.Button>
    </HStack>
  );
}
